import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints } from '@vds-core/theme';
var propTypes = {
  /**
   * React components or HTML elements that will be in the Modal Footer.
   */
  children: PropTypes.any.isRequired,

  /**
   * @ignore
   * Padding styles for the ModalFooter
   */
  padding: PropTypes.string,

  /**
   * @ignore
   * Override Button group bottom padding
   */
  noButtonPadding: PropTypes.bool,

  /**
   * @ignore
   */
  toggleModal: PropTypes.func
};
var defaultProps = {
  padding: calculateRem(0, 14, 0, 14),
  noButtonPadding: false,
  toggleModal: function toggleModal() {}
};
var StyledFooter = /*#__PURE__*/styled.footer.attrs({
  'data-testid': 'modal-footer'
}).withConfig({
  displayName: "StyledFooter",
  componentId: "sc-d4rmcr-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: ", ";\n  width: 100%;\n  flex-shrink: 0;\n  padding: ", ";\n\n  ", ";\n"])), function (_ref) {
  var footerDisplay = _ref.footerDisplay;
  return footerDisplay ? footerDisplay : 'block';
}, function (_ref2) {
  var paddingprop = _ref2.paddingprop;
  return paddingprop;
}, function (_ref3) {
  var noButtonPadding = _ref3.noButtonPadding;
  return noButtonPadding && "\n    @media (min-width: ".concat(breakpoints.md, ") {\n      div {\n        padding-bottom: 0 !important;\n      }\n    }\n  ");
});

var ModalFooter = function ModalFooter(props) {
  var padding = props.padding,
      footerDisplay = props.footerDisplay,
      noButtonPadding = props.noButtonPadding,
      toggleModal = props.toggleModal;
  var children = React.Children.map(props.children, function (child, index) {
    if (child && /*#__PURE__*/React.isValidElement(child) && child.type && child.type.name && child.type.name === 'Button' && child.props && child.props.close) {
      var closeModal = function closeModal(e) {
        child.props.onClick && child.props.onClick(e);
        toggleModal();
      };

      return /*#__PURE__*/React.cloneElement(child, {
        onClick: function onClick(e) {
          return closeModal(e);
        },
        key: index + 1
      });
    } else {
      return child;
    }
  });
  return /*#__PURE__*/React.createElement(StyledFooter, {
    paddingprop: padding,
    footerDisplay: footerDisplay,
    noButtonPadding: noButtonPadding
  }, children);
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
export default ModalFooter;